<template>
    <div class="p-5">
        <div class="d-flex justify-content-start align-items-center mb-5" v-if="supporterData">
            <div class="c-title">
                Supporters:
                <span v-text="formatNumber(supporterData.num_of_supporters)"></span>
            </div>
            <div class="c-title ml-5">
                Total (Gross):
                <span v-text="formatCurrency(supporterData.total_amount)"></span>
            </div>
            <div class="c-title ml-5">
                Total (Net):
                <span v-text="formatCurrency(supporterData.total_payout_amount)"></span>
            </div>
        </div>

        <div class="d-flex justify-content-start align-content-center">
            <div class="form-group filter-date">
                <label for="from-date">From date</label>
                <datepicker placeholder="mm/dd/yyyy"
                            clearButton
                            clearButtonIcon="fa fa-times-circle mt-2 clear-filter-button"
                            :format="customFormatter" class="form-control date" id="from-date"
                            v-model="filterStartDate" name="startdate">
                </datepicker>
            </div>
            <div class="form-group filter-date ml-4">
                <label for="to-date">To date</label>
                <datepicker placeholder="mm/dd/yyyy"
                            clearButton
                            clearButtonIcon="fa fa-times-circle mt-2 clear-filter-button"
                            :format="customFormatter" class="form-control date" id="to-date"
                            v-model="filterToDate" name="todate">
                </datepicker>
            </div>

            <div class="row input no-gutters ml-4">
                <multiselect class="donation-filter"
                             placeholder="Campaign"
                             label="label"
                             track-by="value"
                             select-label=""
                             selected-label=""
                             deselect-label=""
                             v-model="filterCampaign" :options="filterCampaignItems" :close-on-select="false" :multiple="true">
                    <template slot="selection" slot-scope="{ values, search, isOpen }">
                        <span  v-if="values.length > 1"  class="multiselect__single" v-show="!isOpen">{{ values.length }} campaigns</span>
                        <span  v-if="values.length === 1"  class="multiselect__single" v-show="!isOpen">{{ subStringLabel(values[0].label) }}</span>
                    </template>
                    <template slot="caret">
                        <div class="multiselect__select">
                            <a @click.prevent="() => {}">
                                <i
                                    class="fa fa-chevron-circle-down mt-2"
                                    style="font-size: 20px; color: #40b8dc"
                                />
                            </a>
                        </div>
                    </template>
                    <template slot="option" slot-scope="scope">
                        <div v-if="scope.option.value === 'all'" @click="clearFilter('campaign')">
                            {{ scope.option.label }}
                        </div>
                        <span class="checkbox-label" v-else>
                            {{ scope.option.label }}
                            <input class="test" type="checkbox" :checked="filterCampaign.includes(scope.option)" @focus.prevent/>
                        </span>
                    </template>
                </multiselect>
            </div>
            <div class="row input no-gutters ml-4">
                <multiselect class="donation-filter"
                             placeholder="Designation"
                             label="label"
                             track-by="value"
                             select-label=""
                             selected-label=""
                             deselect-label=""
                             v-model="filterDesignation" :options="filterDesignationItems" :close-on-select="false" :multiple="true">
                    <template slot="selection" slot-scope="{ values, search, isOpen }">
                        <span  v-if="values.length > 1"  class="multiselect__single" v-show="!isOpen">{{ values.length }} designations</span>
                        <span  v-if="values.length === 1"  class="multiselect__single" v-show="!isOpen">{{ subStringLabel(values[0].label) }}</span>
                    </template>
                    <template slot="caret">
                        <div class="multiselect__select">
                            <a @click.prevent="() => {}">
                                <i
                                    class="fa fa-chevron-circle-down mt-2"
                                    style="font-size: 20px; color: #40b8dc"
                                />
                            </a>
                        </div>
                    </template>
                    <template slot="option" slot-scope="scope">
                        <div v-if="scope.option.value === 'all'" @click="clearFilter('designation')">
                            {{ scope.option.label }}
                        </div>
                        <span class="checkbox-label" v-else>
                            {{ scope.option.label }}
                            <input class="test" type="checkbox" :checked="filterDesignation.includes(scope.option)" @focus.prevent/>
                        </span>
                    </template>
                </multiselect>
            </div>
        </div>

        <div class="d-flex justify-content-start align-content-center">
            <div class="row input no-gutters">
                <multiselect class="donation-filter"
                             placeholder="Distribution"
                             label="label"
                             track-by="value"
                             select-label=""
                             selected-label=""
                             deselect-label=""
                             v-model="filterDistribution" :options="filterDistributionItems" :close-on-select="false" :multiple="true">
                    <template slot="selection" slot-scope="{ values, search, isOpen }">
                        <span  v-if="values.length > 1"  class="multiselect__single" v-show="!isOpen">{{ values.length }} distributions</span>
                        <span  v-if="values.length === 1"  class="multiselect__single" v-show="!isOpen">{{ subStringLabel(values[0].label) }}</span>
                    </template>
                    <template slot="caret">
                        <div class="multiselect__select">
                            <a @click.prevent="() => {}">
                                <i
                                    class="fa fa-chevron-circle-down mt-2"
                                    style="font-size: 20px; color: #40b8dc"
                                />
                            </a>
                        </div>
                    </template>
                    <template slot="option" slot-scope="scope">
                        <div v-if="scope.option.value === 'all'" @click="clearFilter('distribution')">
                            {{ scope.option.label }}
                        </div>
                        <span class="checkbox-label" v-else>
                            {{ scope.option.label }}
                            <input class="test" type="checkbox" :checked="filterDistribution.includes(scope.option)" @focus.prevent/>
                        </span>
                    </template>
                </multiselect>
            </div>
            <div class="row input no-gutters ml-4">
                <multiselect class="donation-filter"
                             placeholder="Widget"
                             label="label"
                             track-by="value"
                             select-label=""
                             selected-label=""
                             deselect-label=""
                             v-model="filterWidget" :options="filterWidgetItems" :close-on-select="false" :multiple="true">
                    <template slot="selection" slot-scope="{ values, search, isOpen }">
                        <span  v-if="values.length > 1"  class="multiselect__single" v-show="!isOpen">{{ values.length }} widgets</span>
                        <span  v-if="values.length === 1"  class="multiselect__single" v-show="!isOpen">{{ subStringLabel(values[0].label) }}</span>
                    </template>
                    <template slot="caret">
                        <div class="multiselect__select">
                            <a @click.prevent="() => {}">
                                <i
                                    class="fa fa-chevron-circle-down mt-2"
                                    style="font-size: 20px; color: #40b8dc"
                                />
                            </a>
                        </div>
                    </template>
                    <template slot="option" slot-scope="scope">
                        <div v-if="scope.option.value === 'all'" @click="clearFilter('widget')">
                            {{ scope.option.label }}
                        </div>
                        <span class="checkbox-label" v-else>
                            {{ scope.option.label }}
                            <input class="test" type="checkbox" :checked="filterWidget.includes(scope.option)" @focus.prevent/>
                        </span>
                    </template>
                </multiselect>
            </div>
            <div class="row input no-gutters ml-4">
                <multiselect class="donation-filter"
                             placeholder="Source"
                             label="label"
                             track-by="value"
                             select-label=""
                             selected-label=""
                             deselect-label=""
                             v-model="filterSource" :options="filterSourceItems" :close-on-select="false" :multiple="true">
                    <template slot="selection" slot-scope="{ values, search, isOpen }">
                        <span  v-if="values.length > 1"  class="multiselect__single" v-show="!isOpen">{{ values.length }} sources</span>
                        <span  v-if="values.length === 1"  class="multiselect__single" v-show="!isOpen">{{ subStringLabel(values[0].label) }}</span>
                    </template>
                    <template slot="caret">
                        <div class="multiselect__select">
                            <a @click.prevent="() => {}">
                                <i
                                    class="fa fa-chevron-circle-down mt-2"
                                    style="font-size: 20px; color: #40b8dc"
                                />
                            </a>
                        </div>
                    </template>
                    <template slot="option" slot-scope="scope">
                        <div v-if="scope.option.value === 'all'" @click="clearFilter('source')">
                            {{ scope.option.label }}
                        </div>
                        <span class="checkbox-label" v-else>
                            {{ scope.option.label }}
                            <input class="test" type="checkbox" :checked="filterSource.includes(scope.option)" @focus.prevent/>
                        </span>
                    </template>
                </multiselect>
            </div>
            <div class="row input no-gutters ml-4">
                <multiselect class="donation-filter"
                             placeholder="Recurring"
                             label="label"
                             track-by="value"
                             select-label=""
                             selected-label=""
                             deselect-label=""
                             v-model="filterRecurring" :options="filterRecurringItems" :close-on-select="false" :multiple="true">
                    <template slot="selection" slot-scope="{ values, search, isOpen }">
                        <span  v-if="values.length > 1"  class="multiselect__single" v-show="!isOpen">{{ values.length }} recurring</span>
                        <span  v-if="values.length === 1"  class="multiselect__single" v-show="!isOpen">{{ subStringLabel(values[0].label) }}</span>
                    </template>
                    <template slot="caret">
                        <div class="multiselect__select">
                            <a @click.prevent="() => {}">
                                <i
                                    class="fa fa-chevron-circle-down mt-2"
                                    style="font-size: 20px; color: #40b8dc"
                                />
                            </a>
                        </div>
                    </template>
                    <template slot="option" slot-scope="scope">
                        <div v-if="scope.option.value === 'all'" @click="clearFilter('recurring')">
                            {{ scope.option.label }}
                        </div>
                        <span class="checkbox-label" v-else>
                            {{ scope.option.label }}
                            <input class="test" type="checkbox" :checked="filterRecurring.includes(scope.option)" @focus.prevent/>
                        </span>
                    </template>
                </multiselect>
            </div>
        </div>

        <div class="table-responsive">
            <table class="table">
                <thead class="c-thead">
                    <tr>
                        <th scope="col" style="cursor: pointer"
                            class="h-name"
                            @click="onSort(SORT_ITEMS.name)"
                        >
                            Full name
                            <span class="ml-2" v-if="currentSortBy === SORT_ITEMS.name">
                                <i :class="currentSortOrder === SORT_ORDER.asc ? 'fa-chevron-up' : 'fa-chevron-down'"
                                    class="fa mt-2" style="font-size: 14px;"></i>
                            </span>
                        </th>
                        <th scope="col" class="h-email">Email</th>
                        <th scope="col" class="h-phone">Phone</th>
                        <th scope="col"
                            class="h-donation"
                            style="cursor:pointer;"
                            @click="onSort(SORT_ITEMS.donations)"
                        >
                            Donations
                            <span class="ml-2" v-if="currentSortBy === SORT_ITEMS.donations">
                                <i :class="currentSortOrder === SORT_ORDER.asc ? 'fa-chevron-up' : 'fa-chevron-down'"
                                   class="fa mt-2" style="font-size: 14px;"></i>
                            </span>
                        </th>
                        <th scope="col"
                            class="h-amount"
                            style="cursor:pointer;"
                            @click="onSort(SORT_ITEMS.amount)"
                        >
                            Amount
                            <span class="ml-2" v-if="currentSortBy === SORT_ITEMS.amount">
                                <i :class="currentSortOrder === SORT_ORDER.asc ? 'fa-chevron-up' : 'fa-chevron-down'"
                                   class="fa mt-2" style="font-size: 14px;"></i>
                            </span>
                        </th>
                        <th scope="col" class="h-payout">Payout</th>
                    </tr>
                </thead>
                <tbody v-if="supporters.length">
                    <TableItem
                        v-for="(item, index) in supporters"
                        :key="index"
                        :data="item"
                        @openDonationDetails="openDonationDetails"
                    />
                </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="6" class="text-center">No data</td>
                </tr>
              </tbody>
            </table>
            <div class="d-flex justify-content-center" v-if="totalPage > 1">
              <CustomPagination :activePage="currentPage" :totalPage="totalPage" @paginationHandle="onClickPagging"></CustomPagination>
            </div>
            <modal-donation-details v-if="isShowDonationModal" :data="modalData" @close="isShowDonationModal = false" />
        </div>
    </div>
</template>

<script>
import TableItem from './SupporterTableItem.vue';
import DibbleJs from '@/dibble';
import DibbleApi from '@/api';
import CustomPagination from "@/commons/CustomPagination/CustomPagination.vue";
import ModalDonationDetails
    from "@/components/campaigns/components/ModalDonationDetails.vue";
import {EventBus} from "@/utils/event-bus";
import Datepicker from "vuejs-datepicker";
import Multiselect from 'vue-multiselect'
import _ from "lodash";

const SORT_ITEMS = {
  name: 1,
  donations: 2,
  amount: 3,
};
const SORT_ORDER = {
  asc: 1,
  desc: -1,
};

export default {
    name: 'SupportersList',
    components: {
        CustomPagination,
        TableItem,
        ModalDonationDetails,
        Datepicker, Multiselect
    },
    data() {
        return {
            value: [],
            options: ['list', 'of', 'options'],

            search: '',
            SORT_ITEMS,
            SORT_ORDER,
            supporterData: null,
            supporters: [],
            displayCampaigns: [],
            totalPage: 0,
            currentPage: 1,
            currentSortBy: SORT_ITEMS.name,
            currentSortOrder: SORT_ORDER.asc,
            isShowDonationModal: false,
            modalData: null,
            filterCampaignItems: [],
            filterDesignationItems: [],
            filterDistributionItems: [],
            filterWidgetItems: [],
            filterSourceItems: [],
            filterRecurringItems: [],
            filterStartDate: null,
            filterToDate: null,
            filterCampaign: [],
            filterDesignation: [],
            filterDistribution: [],
            filterWidget: [],
            filterSource: [],
            filterRecurring: [],
        };
    },
    watch: {
        filterStartDate: _.debounce(function () {
            this.getSupporters(0)
        }, 1000),
        filterToDate: _.debounce(function () {
            this.getSupporters(0)
        }, 1000),
        filterCampaign: _.debounce(function () {
            if (this.filterCampaign.length) {
                const allCampaign = this.filterCampaign.find(item => item.value === 'all');
                if (allCampaign) {
                    this.filterCampaign = [];

                    return;
                }
            }

            // group selected items at top
            this.filterCampaignItems = this.filterCampaignItems.sort((a, b) => {
                if (this.filterCampaign.includes(a)) {
                    return -1;
                }
                if (this.filterCampaign.includes(b)) {
                    return 1;
                }
                return 0;
            });

            // add All option at top
            this.filterCampaignItems = this.filterCampaignItems.sort((a, b) => {
                if (a.value === 'all') {
                    return -1;
                }
                if (b.value === 'all') {
                    return 1;
                }
                return 0;
            });

            this.getSupporters(0)
        }, 1000),
        filterDesignation: _.debounce(function () {
            if (this.filterDesignation.length) {
                const allDesignation = this.filterDesignation.find(item => item.value === 'all');
                if (allDesignation) {
                    this.filterDesignation = [];

                    return;
                }
            }

            // group selected items at top
            this.filterDesignationItems = this.filterDesignationItems.sort((a, b) => {
                if (this.filterDesignation.includes(a)) {
                    return -1;
                }
                if (this.filterDesignation.includes(b)) {
                    return 1;
                }
                return 0;
            });

            // add All option at top
            this.filterDesignationItems = this.filterDesignationItems.sort((a, b) => {
                if (a.value === 'all') {
                    return -1;
                }
                if (b.value === 'all') {
                    return 1;
                }
                return 0;
            });

            this.getSupporters(0)
        }, 1000),

        filterDistribution: _.debounce(function () {
            if (this.filterDistribution.length) {
                const allDistribution = this.filterDistribution.find(item => item.value === 'all');
                if (allDistribution) {
                    this.filterDistribution = [];

                    return;
                }
            }

            // group selected items at top
            this.filterDistributionItems = this.filterDistributionItems.sort((a, b) => {
                if (this.filterDistribution.includes(a)) {
                    return -1;
                }
                if (this.filterDistribution.includes(b)) {
                    return 1;
                }
                return 0;
            });

            // add All option at top
            this.filterDistributionItems = this.filterDistributionItems.sort((a, b) => {
                if (a.value === 'all') {
                    return -1;
                }
                if (b.value === 'all') {
                    return 1;
                }
                return 0;
            });

            this.getSupporters(0)
        }, 1000),

        filterWidget: _.debounce(function () {
            if (this.filterWidget.length) {
                const allWidget = this.filterWidget.find(item => item.value === 'all');
                if (allWidget) {
                    this.filterWidget = [];

                    return;
                }
            }

            // group selected items at top
            this.filterWidgetItems = this.filterWidgetItems.sort((a, b) => {
                if (this.filterWidget.includes(a)) {
                    return -1;
                }
                if (this.filterWidget.includes(b)) {
                    return 1;
                }
                return 0;
            });

            // add All option at top
            this.filterWidgetItems = this.filterWidgetItems.sort((a, b) => {
                if (a.value === 'all') {
                    return -1;
                }
                if (b.value === 'all') {
                    return 1;
                }
                return 0;
            });

            this.getSupporters(0)
        }, 1000),

        filterSource: _.debounce(function () {
            if (this.filterSource.length) {
                const allSource = this.filterSource.find(item => item.value === 'all');
                if (allSource) {
                    this.filterSource = [];

                    return;
                }
            }

            // group selected items at top
            this.filterSourceItems = this.filterSourceItems.sort((a, b) => {
                if (this.filterSource.includes(a)) {
                    return -1;
                }
                if (this.filterSource.includes(b)) {
                    return 1;
                }
                return 0;
            });

            // add All option at top
            this.filterSourceItems = this.filterSourceItems.sort((a, b) => {
                if (a.value === 'all') {
                    return -1;
                }
                if (b.value === 'all') {
                    return 1;
                }
                return 0;
            });

            this.getSupporters(0)
        }, 1000),

        filterRecurring: _.debounce(function () {
            if (this.filterRecurring.length) {
                const allRecurring = this.filterRecurring.find(item => item.value === 'all');
                if (allRecurring) {
                    this.filterRecurring = [];

                    return;
                }
            }

            // group selected items at top
            this.filterRecurringItems = this.filterRecurringItems.sort((a, b) => {
                if (this.filterRecurring.includes(a)) {
                    return -1;
                }
                if (this.filterRecurring.includes(b)) {
                    return 1;
                }
                return 0;
            });

            // add All option at top
            this.filterRecurringItems = this.filterRecurringItems.sort((a, b) => {
                if (a.value === 'all') {
                    return -1;
                }
                if (b.value === 'all') {
                    return 1;
                }
                return 0;
            });

            this.getSupporters(0)
        }, 1000),
    },
    methods: {
        subStringLabel(label) {
            return label.length > 20 ? label.substring(0, 20) + '...' : label;
        },
        onSort(value) {
            if (value === this.currentSortBy) {
                this.currentSortOrder = this.SORT_ORDER.asc === this.currentSortOrder ? this.SORT_ORDER.desc : this.SORT_ORDER.asc;
            } else {
                this.currentSortBy = value;
                this.currentSortOrder = SORT_ORDER.desc;
            }

            this.totalPage = 0;
            this.getSupporters(0);
        },
        getFilters() {
            const data = {
                '#request': DibbleApi.api.supporterGetFilters,
            };
            DibbleJs.callApiRequest(data, (response) => {
                if (DibbleApi.isResponseSuccess(response)) {
                    this.filterCampaignItems.push({
                        value: 'all',
                        label: '-All-',
                    });

                    this.filterDesignationItems.push({
                        value: 'all',
                        label: '-All-',
                    });

                    this.filterDistributionItems.push({
                        value: 'all',
                        label: '-All-',
                    });

                    this.filterWidgetItems.push({
                        value: 'all',
                        label: '-All-',
                    });

                    this.filterSourceItems.push({
                        value: 'all',
                        label: '-All-',
                    });

                    this.filterRecurringItems.push({
                        value: 'all',
                        label: '-All-',
                    });

                    this.filterCampaignItems = this.filterCampaignItems.concat(response.campaigns.map(item => {
                        return {
                            value: item.campaign_id,
                            label: item.title,
                        };
                    }));

                    this.filterDesignationItems = this.filterDesignationItems.concat(response.designations.map(item => {
                        return {
                            value: item.designation_id,
                            label: item.name,
                        };
                    }));


                    this.filterDistributionItems = this.filterDistributionItems.concat(response.distributions.map(item => {
                        return {
                            value: item.distribution_id,
                            label: item.title,
                        };
                    }));


                    this.filterWidgetItems = this.filterWidgetItems.concat(response.widgets.map(item => {
                        return {
                            value: item.widget_id,
                            label: item.name,
                        };
                    }));

                    for (const id in response.sources) {
                        this.filterSourceItems.push({
                            value: id,
                            label: response.sources[id],
                        });
                    }

                    for (const id in response.recurring) {
                        this.filterRecurringItems.push({
                            value: id,
                            label: response.recurring[id],
                        });
                    }
                } else {
                    DibbleJs.toastErrorMessage(response.message);
                }
            });
        },
        getSupporters(page = 0) {
            DibbleJs.showLoader();
            const data = {
                '#request': DibbleApi.api.supporterGetAll,
                page,
                sort_by: this.currentSortBy,
                sort_order: this.currentSortOrder,
                search_string: this.search,
                filters: []
            };

            if (this.filterStartDate) {
                data.from_date = this.$moment(this.filterStartDate).format('YYYY-MM-DD');
            }

            if (this.filterToDate) {
                data.to_date = this.$moment(this.filterToDate).format('YYYY-MM-DD');
            }

            if (this.filterCampaign.length) {
                data.filters.push({
                    filter_type: 1,
                    values: this.filterCampaign.map(item => item.value),
                });
            }

            if (this.filterDesignation.length) {
                data.filters.push({
                    filter_type: 2,
                    values: this.filterDesignation.map(item => item.value),
                });
            }

            if (this.filterDistribution.length) {
                data.filters.push({
                    filter_type: 4,
                    values: this.filterDistribution.map(item => item.value),
                });
            }

            if (this.filterWidget.length) {
                data.filters.push({
                    filter_type: 3,
                    values: this.filterWidget.map(item => item.value),
                });
            }

            if (this.filterSource.length) {
                data.filters.push({
                    filter_type: 5,
                    values: this.filterSource.map(item => item.value),
                });
            }

            if (this.filterRecurring.length) {
                data.filters.push({
                    filter_type: 6,
                    values: this.filterRecurring.map(item => item.value),
                });
            }

            DibbleJs.callApiRequest(data, (response) => {
                if (DibbleApi.isResponseSuccess(response)) {
                    if (page === 0) {
                      this.totalPage = response.num_of_pages;
                      this.currentPage = 1;
                    }

                    this.supporterData = response;
                    this.supporters = response.supporters;
                } else {
                    DibbleJs.toastErrorMessage(response.message);
                }
                DibbleJs.hideLoader();
            });
        },
        onClickPagging(page) {
            this.currentPage = page.pageIndex;
            this.getSupporters(page.pageIndex - 1);
        },
        openDonationDetails(data) {
            this.modalData = data;
            this.isShowDonationModal = true;
        },
        formatNumber(number) {
            return new Intl.NumberFormat('en-US').format(number);
        },
        formatCurrency(amount) {
            return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(amount);
        },
        customFormatter(date) {
            return this.$moment(date).format("MM/DD/YYYY");
        },
        clearFilter(itemName) {
            switch (itemName) {
                case 'campaign':
                    this.filterCampaign = [];
                    break;

                case 'designation':
                    this.filterDesignation = [];
                    break;

                case 'distribution':
                    this.filterDistribution = [];
                    break;

                case 'widget':
                    this.filterWidget = [];
                    break;

                case 'source':
                    this.filterSource = [];
                    break;

                case 'recurring':
                    this.filterRecurring = [];
                    break;
            }
        }
    },
    created() {
        this.getFilters();
        this.getSupporters();
        EventBus.$on('searchSupporters', (search) => {
            this.search = search;
            this.getSupporters(0);
        });
    },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss" scoped>
.c-cancel-btn {
    border-radius: 20px;
    background: #d9d9d9;
    box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
    font-size: 20px;
    font-weight: 700;
    width: 120px;
    color: #555e67;
    line-height: 140%;
}
.c-title {
    color: #2178ab;
    font-size: 22px;
    font-weight: 700;
}
.c-tab-list {
    border-radius: 20px;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
}
.c-btn-add {
    color: #fff;
    width: 61px;
    height: 47px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #2178ab;
    border-radius: 20px;
    font-size: 24px;
    box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
}
.c-thead {
    th {
        color: #41B8DC;
        font-size: 16px;
        font-weight: 600;
        line-height: 24px;

        &.h-name {
            width: 20%;
        }
        &.h-phone {
            width: 10%;
        }
        &.h-email {
            width: 20%;
        }
        &.h-donation {
            width: 15%;
            text-align: right;
        }
        &.h-amount {
            width: 15%;
            text-align: right;
        }
        &.h-payout {
            width: 15%;
            text-align: right;
        }
    }
}
.filter-date, .donation-filter {
    width: 340px;
    background-color: #e1e7e9;
    padding: 5px 16px 8px 16px;
    border-radius: 12px;
    position: relative;
    height: 59px;
    cursor: pointer;
    box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
    @media (max-width: 1750px) {
        width: auto;
    }

}
.donation-filter {
    width: 310px;
    height: 45px;

    /* Fix width on smaller screen*/
    @media (max-width: 1750px) {
        width: auto;
    }
}
</style>
<style lang="scss">
.filter-date {
    .form-control {
        background: none;

        div {
            input {
                background: none;
                border: none;
            }
        }

        .vdp-datepicker__clear-button {
            position: absolute;
            right: 1px;
            bottom: 10px;
        }
    }
}
.donation-filter {
    .multiselect__tags {
        background: transparent;
    }

    .multiselect__input, .multiselect__single {
        background: transparent;
        border: none;
        padding-top: 5px;
        color: #969fa2;
    }

    .multiselect__select {
        right: 3px;
        top: 9px;
        &:before {
            display: none
        }
    }
}

.checkbox-label {
    display: block;
}

.test {
    position: absolute;
    right: 1vw;
    width: 18px;
    height: 18px;
}
.clear-filter-button {
    font-size: 20px; color: #40b8dc;
}
</style>

